/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ShouldRevalidateFunctionArgs } from 'react-router';
import { shouldRevalidate as shouldRevalidateHome } from './home';

/**
 * Revalidation for `/page/:slug`. The loader fetches PD content by `slug`, so client navigations
 * between content pages (same route, different param) must re-run the loader. The home policy
 * suppresses param-only changes and would leave stale page content while the URL updates.
 */
export function shouldRevalidate(args: ShouldRevalidateFunctionArgs): boolean {
    if (args.currentParams.slug !== args.nextParams.slug) {
        return true;
    }

    return shouldRevalidateHome(args);
}
